import { createRouter } from '@tanstack/react-router';

import { Loader } from './modules/Loader/main';
import { routeTree } from './routeTree.gen';

// Create a new router instance
export const router = createRouter({
  routeTree,
  // Worded, with a way back (design system: every state says what to do next).
  defaultNotFoundComponent() {
    return (
      <div className="flex min-h-[calc(100dvh-var(--app-bar-height,90px))] items-center justify-center px-4">
        <div className="max-w-sm text-center">
          <h1 className="text-foreground text-xl font-bold">Page not found</h1>
          <p className="text-muted-foreground mt-2 text-sm">
            This address doesn&apos;t match a page. Check it for typos, or go back and try again.
          </p>
          <a
            href="/dashboard-home"
            className="text-link mt-3 inline-block text-sm underline-offset-4 hover:underline"
          >
            Go to the dashboard
          </a>
        </div>
      </div>
    );
  },
  defaultErrorComponent: ({ error }) => {
    console.error(error);
    return (
      // Uncaught ReferenceError: path is not defined
      <div>
        <div>We had an error, check the console for information</div>
        <p>{error.message}</p>
      </div>
    );
  },
  defaultPendingComponent: Loader,
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  context: {
    queryClient: undefined!, // Will be set in App.tsx after queryClient is initialized
    authContext: undefined!,
    featureFlags: undefined!,
  },
  defaultViewTransition: true,
});
